"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentPageResponseDtoContentTypeEnum = void 0;
exports.ContentPageResponseDtoContentTypeEnum = {
    All: 'all',
    TermsAndConditions: 'terms_and_conditions',
    Faqs: 'faqs',
    HowItWorks: 'how_it_works',
    PrivacyPolicy: 'privacy_policy'
};
